module.exports = __webpack_public_path__ + "static/media/9C.23873bdd.svg";